import { Flex } from '@chakra-ui/react';
import { filterCategories } from '~/components/CategoryTag/CategoryTag.utils';
import { myAgencyCreatorCardTrackId } from '~/screens/MyAgency/components/StackView/CreatorInfo/constants';
import { ICreator } from '~/types';

interface Props {
  creator: ICreator;
}
export const CategoryTagCard: React.FC<Props> = ({ creator }) => {
  const { categoryAgency } = creator;
  const filteredVerticals = filterCategories(categoryAgency);

  return (
    <Flex
      justify="wrap"
      alignItems="center"
      gap={2}
      track-id={myAgencyCreatorCardTrackId.verticals}
    >
      {filteredVerticals.map((vertical) => (
        <div
          key={vertical.name}
          className="flex items-center justify-center rounded-8 bg-[var(--media-kit-background-alpha)] px-2 py-1 text-[var(--media-kit-text-base)]"
        >
          <span className="text-14">{vertical.name}</span>
        </div>
      ))}
    </Flex>
  );
};
